// frontend/src/recording/GlobalRecordingBar.js
//
// Flytande inspelningsrad som syns på ALLA sidor när en diktering pågår.
// Gör att man kan boka i kalendern, öppna journaler, ta betalt i kassan
// m.m. utan att tappa kontrollen över inspelningen — och hitta tillbaka.

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useRecordingSession } from './RecordingContext';
import './GlobalRecordingBar.css';

const formatTime = (secs) => {
  const m = Math.floor(secs / 60);
  const s = secs % 60;
  return `${m}:${String(s).padStart(2, '0')}`;
};

const GlobalRecordingBar = () => {
  const rec = useRecordingSession();
  const navigate = useNavigate();

  if (!rec || rec.phase === 'idle') return null;

  const goToJournal = () => {
    if (rec.patientId) {
      navigate(`/patients/${rec.patientId}?tab=journal`);
    }
  };

  return (
    <div className={`global-recording-bar phase-${rec.phase}`}>
      {rec.phase === 'recording' && (
        <>
          <span className="grb-status">
            <span className="grb-dot"></span>
            Spelar in{rec.patientName ? ` — ${rec.patientName}` : ''} · {formatTime(rec.currentTime)}
            {rec.uploadFailures > 0 && (
              <i className="fas fa-exclamation-triangle grb-warn"
                 title={`${rec.uploadFailures} ljudsnuttar väntar på transkribering (görs om automatiskt)`}></i>
            )}
          </span>
          <button className="grb-btn" onClick={goToJournal}>
            <i className="fas fa-book-medical"></i> Till journalen
          </button>
          <button className="grb-btn grb-stop" onClick={rec.stopAndGenerate}>
            <i className="fas fa-stop"></i> Stoppa & generera
          </button>
        </>
      )}

      {(rec.phase === 'processing' || rec.phase === 'generating') && (
        <span className="grb-status">
          <i className="fas fa-spinner fa-spin"></i>
          {rec.phase === 'processing' ? ' Bearbetar ljudet…' : ' Genererar journaltext…'}
          {rec.patientName ? ` (${rec.patientName})` : ''}
        </span>
      )}

      {rec.phase === 'done' && (
        <>
          <span className="grb-status">
            <i className="fas fa-check-circle grb-ok"></i>
            Journaltext sparad i utkastet{rec.patientName ? ` — ${rec.patientName}` : ''}
          </span>
          <button className="grb-btn" onClick={() => { goToJournal(); rec.dismiss(); }}>
            Öppna journalen
          </button>
          <button className="grb-btn grb-close" onClick={rec.dismiss} title="Stäng">
            <i className="fas fa-times"></i>
          </button>
        </>
      )}

      {rec.phase === 'error' && (
        <>
          <span className="grb-status grb-error">
            <i className="fas fa-exclamation-triangle"></i> {rec.errorMsg}
          </span>
          <button className="grb-btn grb-close" onClick={rec.dismiss} title="Stäng">
            <i className="fas fa-times"></i>
          </button>
        </>
      )}
    </div>
  );
};

export default GlobalRecordingBar;
